import { useQuery } from '@tanstack/react-query'
import { apiJson } from '@/api/client'
import type { AnalystSummary } from '../types'

export const analystsQueryKey = ['alerts', 'analysts'] as const

interface Response {
  analysts: AnalystSummary[]
}

export function useAnalysts() {
  return useQuery({
    queryKey: analystsQueryKey,
    queryFn: () => apiJson<Response>('/analysts'),
    staleTime: 5 * 60_000,
    select: (data) => data.analysts,
  })
}
